module.exports = __webpack_public_path__ + "static/media/017-book.a153d62e.svg";